
import XButton from 'vux/src/components/x-button/index.vue'

import Long from 'long'
import * as sportsTourUtil from '../../../utils/sports-tour-util'

export default {
name: 'travel-order-card',
components: {
XButton,
},
props: {
order: {
type: Object,
required: true,
},
type: {
type: String,
default: 'normal',
},
},
data() {
return {
}
},
computed: {
orderStatusText() {
const statusFun = this.type === 'custom' ? sportsTourUtil.customOrderStatusText : sportsTourUtil.packageOrderStatusText
return statusFun(this.order.status)
},
payAble() {
const { order } = this
return order.status === 1 || (order.status === 2 && order.restPaymentOpen)
},
services() {
if (!this.order.services) {
return ''
}
const names = this.order.services.map(service => service.name)
return names.join('、')
},
descText1() {
return this.order.status < 4 ? '总 价' : '已支付'
},
descText2() {
let desc = '需预付'
if (this.order.status === 2) {
desc = '已预付'
}
if (this.order.restPaymentOpen) {
desc = '还需支付'
}
return desc
},
actualPay() {
const self = this
const restPay = (self.order.totalPrice - self.order.advancePayment) / 100
return self.order.restPaymentOpen ? restPay : self.order.advancePayment / 100
},
cantactShow() {
return this.$route.name !== 'travel-order-pay'
},
cities() {
const { order } = this

if (order.sportsTourRoute.departureCity !== null) {
return order.sportsTourRoute.departureCity
}

if (!order.sportsTourRoute.targetCitys) {
return ''
}
const targetCitys = order.sportsTourRoute.targetCitys.map(city => city.name)
return targetCitys.join('/')
},
departureStart() {
if (this.order.startTime !== null) {
return this.convertDate(this.order.startTime)
}
return this.convertDate(this.order.sportsTourRoute.departureStart)
},
planDate() {
const departureStart = this.convertDate(this.order.departureStart)
const departureEnd = this.convertDate(this.order.departureEndDate)
return `${departureStart}-${departureEnd}`
},

checkRouteContent() {
const { order } = this
return order.routeStatus > 1 && this.type === 'custom'
},
payText() {
const { order } = this
return order.status === 1 ? '确认支付' : `支付尾款${(order.totalPrice - order.advancePayment) / 100}`
},
},
methods: {
convertDate(longTime) {
if (longTime) {
const timestamp = new Long(longTime.low, longTime.high, longTime.unsigned).toNumber()
const date = new Date(timestamp)
return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`
}
return ''
},

goCustomOrderDetail() {
const { order } = this
this.$router.push({
name: 'sports-tour-custom-intro',
params: {
customOrderId: order.id,
},
})
},
toDetail() {
if (this.order.sportsTourRoute.routeType === 1) {
if (this.order.sportsTourRoute.departureCity !== null) {
window.location.href = `/h5/sportsTourRouteIntroduction_detail/${this.order.sportsTourRoute.id}`
} else {
window.location.href = `/h5/sportsTourRouteIntroductionejs/${this.order.sportsTourRoute.id}`
}
} else {
this.$router.push({ name: 'sports-tour-route-detail', params: { routeId: this.order.sportsTourRoute.id } })
}
},
payOrder() {
this.$router.push({ name: 'travel-order-pay', query: { orderId: this.order.id, type: this.type } })
},
},
}



// WEBPACK FOOTER //
// ./client/components/SportsTour/Order/TravelOrderCard.vue